import {
  CButton,
  CFormTextarea,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from '@coreui/react-pro'
import React, { Dispatch, SetStateAction, useState } from 'react'
import { passCommissionCalculateSubmit } from './model'

type Props = {
  comment: string
  setComment: Dispatch<SetStateAction<string>>
  disabledButton?: boolean
}

export const PassCommissionModal: React.FC<Props> = ({
  comment,
  setComment,
  disabledButton,
}) => {
  const [isVisible, setIsVisible] = useState<boolean>(false)

  const handleSubmit = () => {
    passCommissionCalculateSubmit({
      comment,
      executeUpdate: false,
    })
    setIsVisible(false)
  }

  return (
    <>
      <CButton
        color="primary"
        onClick={() => setIsVisible(true)}
        disabled={disabledButton}
      >
        Pass the commission on to the client
      </CButton>
      <CModal visible={isVisible} onClose={() => setIsVisible(false)} size="lg">
        <CModalHeader closeButton>
          <CModalTitle>Pass Commission to Client</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CFormTextarea
            id="commissionComment"
            value={comment}
            label="Comment"
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
              setComment(e.target.value)
            }
            rows={4}
          />
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setIsVisible(false)}>
            Cancel
          </CButton>
          <CButton
            color="primary"
            onClick={handleSubmit}
            disabled={!comment.trim()}
          >
            OK
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}
